
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import s from './FactFileImageCarousel.module.scss';
import ChevronPrev from '../../../../svgs/chevron_prev.svg';
import ChevronNext from '../../../../svgs/chevron_next.svg';
import Image from '../../../../components/Image';
import FactFileImageCarouselSlide from './FactFileImageCarouselSlide';
const propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
        contentfulId: PropTypes.string,
        contentTypeId: PropTypes.string,
        entryTitle: PropTypes.string,
        image: PropTypes.shape({
            contentfulId: PropTypes.string,
            contentTypeId: PropTypes.string,
            title: PropTypes.string,
            description: PropTypes.string,
            file: PropTypes.shape({
                url: PropTypes.string,
                details: PropTypes.shape({
                    size: PropTypes.number,
                    image: PropTypes.shape({
                        width: PropTypes.number,
                        height: PropTypes.number
                    })
                }),
                fileName: PropTypes.string,
                contentType: PropTypes.string
            })
        }),
        imageCaption: PropTypes.string
    }))
};
const sliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'linear',
    arrows: false,
    draggable: true,
    swipe: true,
    autoplay: false,
    infinite: true,
    speed: 150
};
const FactFileImageCarousel = ({ images = [] }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const sliderRef = useRef(null);
    useEffect(() => {
        // Reset the index when the images prop changes
        setCurrentIndex(0);
        /* istanbul ignore else */
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(0);
        }
    }, [images]);
    const singleImage = images.length === 1;
    return (<div className={s.container}>
      <div className={s.maxDimensions}>
        <div className={s.mainSliderContainer}>
          <Slider {...sliderSettings} className={s.slider} ref={sliderRef} beforeChange={(prevIndex, index) => {
            setCurrentIndex(index);
        }}>
            {images.map((item) => (<div className={s.slide} key={item.contentfulId}>
                <FactFileImageCarouselSlide image={item} key={item.contentfulId}/>
              </div>))}
          </Slider>

          {!singleImage && (<div className={s.controls}>
              <div data-testid="prev-button" className={[s.controlsLeft].join(' ')} onClick={() => {
                sliderRef.current.slickPrev();
                document.activeElement.blur();
            }} onKeyDown={(event) => {
                /* istanbul ignore else */
                if (event.keyCode === 13) {
                    sliderRef.current.slickPrev();
                }
            }} tabIndex="0" role="button" aria-label="Previous">
                <Image imageSet={[{ src: ChevronPrev }]} contain/>
              </div>
              <div data-testid="next-button" className={[s.controlsRight].join(' ')} onClick={() => {
                sliderRef.current.slickNext();
                document.activeElement.blur();
            }} onKeyDown={(event) => {
                /* istanbul ignore else */
                if (event.keyCode === 13) {
                    sliderRef.current.slickNext();
                }
            }} tabIndex="0" role="button" aria-label="Next">
                <Image imageSet={[{ src: ChevronNext }]} contain/>
              </div>
            </div>)}
        </div>
      </div>
      <div className={s.imageCaptionContainer} data-testid="image-caption">
        {images[currentIndex]?.imageCaption}
      </div>
      {!singleImage && (<>
          <div className={s.mobilePreviewSlidesContainer}>
            <ul>
              {images.map((item, index) => {
                return (<li className={currentIndex === index ? s.active : ''} key={item.contentfulId}/>);
            })}
            </ul>
          </div>
          <div className={s.previewSlidesContainer}>
            {images.map((item, index) => (<div className={[s.previewSlide, currentIndex === index ? s.active : ''].join(' ')} key={item.contentfulId} data-testid={`preview-slide-${index}`} tabIndex="0" role="button" aria-label="Previous" onClick={() => {
                    sliderRef.current.slickGoTo(index);
                }} onKeyDown={(event) => {
                    /* istanbul ignore else */
                    if (event.keyCode === 13) {
                        sliderRef.current.slickGoTo(index);
                    }
                }}>
                <FactFileImageCarouselSlide image={item} isPreview isActive={currentIndex === index}/>
              </div>))}
          </div>
        </>)}
    </div>);
};
FactFileImageCarousel.propTypes = propTypes;
export default FactFileImageCarousel;

    async function __Next_Translate__getStaticProps__195ca0cb747__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//FactFile/components/FactFileImageCarousel/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0cb747__ as getStaticProps }
  